import { ServiceTokens } from "$src/domain/ServiceTokens";
import { PagedResult } from "$src/domain/core/PagedResult";
import { Folder } from "$src/domain/customers/Folder";
import type { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { ProjectSummary } from "$src/domain/projects/ProjectSummary";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetProjectsByCustomerId {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository) {}

    async execute(groupStoreId: number, customerId: number, pageNumber: number) : Promise<GroupedProjectsResult> {
        const result = await this.customerRepository.getProjectsByCustomerId(groupStoreId.toString(), customerId.toString(), pageNumber, 100);
    
        return this.groupProjectsByGroup(result);
    }

    groupProjectsByGroup(projectPage: PagedResult<ProjectSummary>): GroupedProjectsResult {
        const groupedProjects = projectPage.items.reduce((groups, project) => {
            const folder = project.folder || { id: 'non_classé', name: 'non classé', type: undefined };
    
            let group = groups.find(g => g.folder.id === folder.id);
    
            if (!group) {
                group = { folder, projects: [] };
                groups.push(group);
            }
    
            group.projects.push(project);
            return groups;
        }, [] as GroupedProject[]);

        return {
            items: groupedProjects,
            totalCount: projectPage.totalCount,
            totalPages: projectPage.totalPages,
            pageNumber: projectPage.pageNumber,
            pageSize: projectPage.pageSize,
            hasNextPage: projectPage.hasNextPage,
            hasPreviousPage: projectPage.hasPreviousPage
        };
    }
}

export const GetProjectsByCustomerIdToken = Symbol('GetProjectsByCustomerIdToken');    

export interface GroupedProjectsResult {
    items: GroupedProject[];
    totalCount: number;
    totalPages: number;
    pageNumber: number;
    pageSize: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export interface GroupedProject {
    folder: Folder;
    projects: ProjectSummary[];
}